import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService, LoansService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-ataglance',
  templateUrl: './ataglance.component.html',
  styleUrls: ['./ataglance.component.css']
})
export class AtaglanceComponent implements OnInit {
  products = [
    {
      "loan_product_id": "29939",
      "loan_title": "School Now Pay Later"
    },
    {
      "loan_product_id": "29940",
      "loan_title": "Teachers Payday Loan"
    },
    {
      "loan_product_id": "29941",
      "loan_title": "School - Working Capital"
    },
    {
      "loan_product_id": "29942",
      "loan_title": "Rent Now Pay Later"
    },
    {
      "loan_product_id": "29943",
      "loan_title": "Rent - Houses"
    },
    {
      "loan_product_id": "29944",
      "loan_title": "Merchants - Working Capital"
    },
    {
      "loan_product_id": "29945",
      "loan_title": "Buy Now Pay Later"
    },
    {
      "loan_product_id": "29946",
      "loan_title": "Hosiptality - Working Capital"
    },
    {
      "loan_product_id": "29947",
      "loan_title": "Hosiptality - Customers"
    },
    {
      "loan_product_id": "29948",
      "loan_title": "Eat - Working Capital"
    },
    {
      "loan_product_id": "29949",
      "loan_title": "Eat - Customers"
    },
    {
      "loan_product_id": "29955",
      "loan_title": "School - MSBM"
    },
    {
      "loan_product_id": "29961",
      "loan_title": "Hospitality - Hygeia hmo"
    },
    {
      "loan_product_id": "29968",
      "loan_title": "School Gap Finance"
    },
    {
      "loan_product_id": "29975",
      "loan_title": "Light Now Pay Later"
    },
    {
      "loan_product_id": "29977",
      "loan_title": "Cinema - BNPL"
    },
    {
      "loan_product_id": "29978",
      "loan_title": "School Fees Gap Finance"
    },
    {
      "loan_product_id": "29983",
      "loan_title": "Merchant Upfront Finance"
    },
    {
      "loan_product_id": "29992",
      "loan_title": "School Improvement Finance"
    },
    {
      "loan_product_id": "29994",
      "loan_title": "Travel"
    },
    {
      "loan_product_id": "29995",
      "loan_title": "PharmFund"
    },
    {
      "loan_product_id": "29998",
      "loan_title": "Social Credit"
    }
  ];
  currentUser: any;
  loading = false;
  data: any;
  loan_product_id = '';
  general_lender = '';
  constructor(public loansService: LoansService, public analytics: AnalyticsService, public approvalService: ApprovalsService, public dataService: DataService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService, public route: ActivatedRoute) {
    this.currentUser = this.storageService.read<any>('currentUser');

  }

  ngOnInit() {
    this.getataglance()
  }
  getataglance() {
    this.loading = true;
    this.loansService.getataglance(this.currentUser.token, this.loan_product_id, this.general_lender)
      .subscribe(result => {
        this.loading = false;
        this.data = result.data;
      });
  }
  downloadDailySnapshots(report_file) {
    window.open(report_file);
  }
}
